import React from 'react';
import Lottie, { LottieProps } from 'react-lottie-player';

import { useDynamicLottie } from '@/hooks/useDynamicLottie';

interface DynamicLottieProps extends Omit<LottieProps, 'animationData'> {
  /** Lottie 파일 경로 */
  id: string;
  /** 로딩 중 표시할 컴포넌트 */
  fallback?: React.ReactNode;
  /** 에러 발생 시 표시할 컴포넌트 */
  errorFallback?: React.ReactNode;
}

export function DynamicLottie({ 
  id, 
  fallback, 
  errorFallback,
  style,
  ...lottieProps 
}: DynamicLottieProps) {
  const { data, loading, error } = useDynamicLottie(id);

  if (loading) {
    return (
      <>
        {fallback || (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 120,
            height: 120,
            ...style,
          }} />
        )}
      </>
    );
  }

  if (error || !data) {
    return (
      <>
        {errorFallback || (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 120,
            height: 120,
            color: '#999',
            fontSize: '12px',
            ...style,
          }} />
        )}
      </>
    );
  }

  return (
    <Lottie animationData={data}
            style={style}
            {...lottieProps} />
  );
}
